import React from "react";


function RadioTextFormatter(props) {
    const {
        value,          // The selected value.
        opt1Value,      // The value to use for option #1.
        opt1Label,      // The label to display for option #1.
        opt2Value,      // ...
        opt2Label,      // ...
        opt3Value,      // ...
        opt3Label,      // ...
        opt4Value,      // ...
        opt4Label,      // ...
        opt5Value,      // ...
        opt5Label,      // ...
        opt6Value,      // ...
        opt6Label,      // ...
        opt7Value,      // ...
        opt7Label,      // ...
    } = props;
    return (
        <>
            {opt1Value === value && <>{opt1Label}</>}
            {opt2Value === value && <>{opt2Label}</>}
            {opt3Value === value && <>{opt3Label}</>}
            {opt4Value === value && <>{opt4Label}</>}
            {opt5Value === value && <>{opt5Label}</>}
            {opt6Value === value && <>{opt6Label}</>}
            {opt7Value === value && <>{opt7Label}</>}
        </>
    );
}

export default RadioTextFormatter;
